import { CustomElement, resolve } from 'aurelia';
import { SourceAdminService } from '../../services';
import template from './source-admin-panel.html';
import './source-admin-panel.css';

// Admin-only modal that lists every scraper source with an on/off switch. Opened from the admin
// menu; all state and the load/save calls live in SourceAdminService. Turning a source off only
// stops future scrapes — rows already stored for it remain visible in the calendar.
export class SourceAdminPanelElement {
  readonly sourceAdmin: SourceAdminService = resolve(SourceAdminService);
}

export const SourceAdminPanel = CustomElement.define({
  name: 'source-admin-panel',
  template
}, SourceAdminPanelElement);
